import { render, staticRenderFns } from "./event_order_detail.vue?vue&type=template&id=9b4f124a&"
import script from "./event_order_detail.vue?vue&type=script&lang=js&"
export * from "./event_order_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports